import { jsonFetch } from "@/lib/helpers";
import { GuestyListings } from "../../../models/integrations/guesty.models";
import { getGuestyListingsUrl } from "./api-url.constants";
import { GuestyListingsApiDTO } from "./dtos";
import { mapGuestyListingsDTOToGuestyListings } from "./mappers";

export const getGuestyListings = async (userId?: string): Promise<GuestyListings[]> => {
  const response = await jsonFetch<GuestyListingsApiDTO>(getGuestyListingsUrl(userId));
  return mapGuestyListingsDTOToGuestyListings(response.data);
};
